import SQL from 'sql.js'

let getLocalDb = (store, deckId) => {
  if (typeof store.state.dbObject[deckId] === 'undefined') {
    return new Promise((resolve, reject) => {
      // console.log('DB from SERVER : Requested ', deckId)
      let xhr = new XMLHttpRequest()
      // xhr.open('GET', process.env.DB_URL, true)
      xhr.open('GET', process.env.API_URL + `/ws/playerservice/deck/${deckId}/dbfile`, true)
      xhr.responseType = 'arraybuffer'
      xhr.setRequestHeader('Authorization', 'Bearer ' + store.state.token)

      xhr.onload = function (e) {
        let dbObject = new Uint8Array(this.response)
        // console.log('DB from SERVER : Loaded')
        if (dbObject) {
          let dataDBFile = []
          for (let i = 0; i < dbObject.length; ++i) {
            dataDBFile[i] = String.fromCharCode(dbObject[i])
          }
          let db = {}
          db[deckId] = dataDBFile.join('')
          store.commit('setDbObject', db)

          const db1 = new SQL.Database(store.state.dbObject[deckId])
          const query = `SELECT * from levels ORDER BY level_number ASC`
          const levelContents = db1.exec(query)
          store.commit('setLevelsCount', levelContents[0].values.length - 1)

          resolve(store.state.dbObject[deckId])
        } else {
          reject(Error('DB not found!'))
        }
      }
      xhr.send()
    })
  } else {
    return new Promise((resolve, reject) => {
      // console.log('DB from Local : Requested')
      // console.log(state.dbObject)
      resolve(store.state.dbObject[deckId])
    })
  }
}

export default getLocalDb



// WEBPACK FOOTER //
// ./src/store/db.js